import { template as template_19c58a8d43394688bdc92b8eb91ca0a2 } from "@ember/template-compiler";
import SiteDocumentsSharedAutosaveMessage from 'client-portal/components/site/documents/shared/autosave-message';
import t from 'ember-intl/helpers/t';
export default template_19c58a8d43394688bdc92b8eb91ca0a2(`
  <header class="intake-header">
    <h1>{{t "site.pages.waitlistIntake"}}</h1>
    <div class="title-rule" aria-hidden="true"></div>

    {{#unless @isComplete}}
      <div class="autosave" data-test-autosave-displayed={{@isAutosaveDisplayed}}>
        <SiteDocumentsSharedAutosaveMessage
          @tagName=""
          @isDisplayed={{@isAutosaveDisplayed}}
          @autosaveTask={{@autosaveTask}}
        />
      </div>
    {{/unless}}
  </header>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
